<template>
    <div class="container" v-if="editor">
        <editor-content :editor="editor" />

        <div
            :class="{
                'character-count': true,
                'character-count--warning':
                    editor.storage.characterCount.characters() === limit,
            }"
        >
            <!-- <svg
          height="20"
          width="20"
          viewBox="0 0 20 20"
        >
          <circle
            r="10"
            cx="10"
            cy="10"
            fill="#e9ecef"
          />
          <circle
            r="5"
            cx="10"
            cy="10"
            fill="transparent"
            stroke="currentColor"
            stroke-width="10"
            :stroke-dasharray="`calc(${percentage} * 31.4 / 100) 31.4`"
            transform="rotate(-90) translate(-20)"
          />
          <circle
            r="6"
            cx="10"
            cy="10"
            fill="white"
          />
        </svg> -->

            {{ editor.storage.characterCount.characters() }} /
            {{ limit }} characters
            <!-- <br> -->
            <!-- {{ editor.storage.characterCount.words() }} words -->
        </div>
        <div class="hidden" ref="textbox">
            <slot />
        </div>
    </div>
</template>

<script>
import CharacterCount from "@tiptap/extension-character-count";
import StarterKit from "@tiptap/starter-kit";
import Text from "@tiptap/extension-text";
import { Editor, EditorContent } from "@tiptap/vue-2";

export default {
    components: {
        EditorContent,
    },

    data() {
        return {
            editor: null,
            limit: 300,
        };
    },

    mounted() {
        this.editor = new Editor({
            extensions: [
                StarterKit,
                CharacterCount.configure({
                    limit: this.limit,
                }),
            ],
            content: ``,
        });

        this.editor.on("update", this.handle);
    },

    methods: {
        handle() {
            this.$refs.textbox.querySelector("textarea").value =
                this.clean_text;
        },
    },

    computed: {
        percentage() {
            return Math.round(
                (100 / this.limit) *
                    this.editor.storage.characterCount.characters()
            );
        },
        clean_text() {
            return this.editor.getText();
        },
    },

    beforeUnmount() {
        this.editor.destroy();
    },
};
</script>

<style lang="scss">
/* Basic editor styles */
.tiptap {
    height: 100%;

    :first-child {
        margin-top: 0;
    }
    p {
        font-size: 12px;
    }
}

/* Character count */
.character-count {
    align-items: center;
    color: var(--bs-gray-600);
    display: flex;
    font-size: 0.6rem;
    gap: 0.5rem;

    svg {
        color: var(--purple);
    }

    &--warning,
    &--warning svg {
        color: var(--bs-red);
    }
}
</style>
